import type {
  EligibilityType,
  StakeAccountType,
} from "utils/stake-input-types";

export enum PositionAction {
  Stake,
  Redelegate,
  Unstake,
}

export enum PositionType {
  Raw,
  Liquid,
  Native,
  MarinadeNative,
  LST,
  LP,
  MNDE,
}

export interface WalletPosition {
  type: PositionType;
  title: string;
  subtitle: string;
  balance: number;
  balanceInSol: number;
  apy: number;
  stakeAccountAddress?: string;
  stakeAccountAddresses?: string[];
  stakePoolAddress?: string;
  icon?: string;
  recommended?: boolean;
  stakeAccountType?: StakeAccountType;
  eligibilityType?: EligibilityType;
  validatorVoteAddress?: string;
  lstId?: string;
  symbol?: string;
}

export interface WalletPositionWithLockup extends WalletPosition {
  lockupUnixTimestamp: number;
}
